import React from "react";
import {
    Navigate,
} from "react-router-dom";

const ResourcesVideosListComponent = React.lazy(() => import("../../../../../components/container-videos/components/list/page"));


export const videosRoute = [
    {
        path: 'list',
        element: <ResourcesVideosListComponent />,
    },
    {
        path: '',
        element: <Navigate replace to="/resources/videos/list" />
    },
];